import { c as _c } from "react/compiler-runtime";
import { useContactsByEmail } from 'modules/mailing/email-statistics/hooks/use-contacts-by-email';
import { StatisticsFilterInterface } from 'modules/mailing/email-statistics/types/email-statistics-filter-interface';
import React, { useEffect, useRef, useState } from 'react';
import { FormSelectAsyncMultiple } from 'shared/components/form-select/form-select-async-multiple';
interface EmailStatisticsEmailFilterProps {
  contacts: StatisticsFilterInterface['contacts'];
  onChangeContacts: (value: StatisticsFilterInterface['contacts']) => void;
}
const EmailStatisticsEmailFilter = t0 => {
  const $ = _c(19);
  const {
    contacts,
    onChangeContacts
  } = t0;
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const searchTimerRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const {
    contactsFilter,
    abort,
    isValidating
  } = useContactsByEmail(email);
  let t1;
  if ($[0] !== contactsFilter?.items) {
    t1 = contactsFilter?.items.map(_temp);
    $[0] = contactsFilter?.items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const data = t1;
  let t2;
  let t3;
  if ($[2] !== abort || $[3] !== search) {
    t2 = () => {
      if (search) {
        setIsTyping(true);
      }
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
        abort();
      }
      searchTimerRef.current = setTimeout(() => {
        setEmail(search);
        setIsTyping(false);
      }, 1500);
    };
    t3 = [abort, search];
    $[2] = abort;
    $[3] = search;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  const isFetching = isValidating && !contactsFilter || isTyping;
  const t4 = isFetching ? undefined : data;
  let t5;
  if ($[6] !== data || $[7] !== onChangeContacts) {
    t5 = contactIds => {
      const contacts_0 = data?.filter(el => contactIds.includes(el.id));
      onChangeContacts(contacts_0 ?? []);
    };
    $[6] = data;
    $[7] = onChangeContacts;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== contacts) {
    t6 = contacts.map(_temp2);
    $[9] = contacts;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = contactsFilter?.hasMore ? 100 : undefined;
  let t8;
  if ($[11] !== contacts || $[12] !== isFetching || $[13] !== search || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <FormSelectAsyncMultiple search={search} onSearchChange={setSearch} staticData={contacts} data={t4} onChange={t5} value={t6} isFetching={isFetching} moreItems={t7} className="w-[300px]" />;
    $[11] = contacts;
    $[12] = isFetching;
    $[13] = search;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default EmailStatisticsEmailFilter;
function _temp(contact) {
  return {
    id: contact.id,
    caption: contact.email
  };
}
function _temp2(el_0) {
  return el_0.id;
}